var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.75 2.5H17.5V3.25V10.0002V10.3108L17.2804 10.5305L10.9264 16.8858L10.9263 16.886C10.7312 17.081 10.4996 17.2357 10.2447 17.3412C9.98981 17.4467 9.71664 17.5009 9.44079 17.5008C9.16494 17.5007 8.89181 17.4463 8.637 17.3406C8.38219 17.2349 8.1507 17.0801 7.95576 16.8849L7.93367 16.8628L3.1149 12.0441C2.9198 11.849 2.76504 11.6175 2.65945 11.3626C2.55386 11.1078 2.49951 10.8347 2.49951 10.5588C2.49951 10.2829 2.55386 10.0098 2.65945 9.75495C2.76503 9.50014 2.91976 9.26862 3.11482 9.07362L3.1149 9.07354L9.46948 2.71964L9.68914 2.5H9.99978H16.75ZM16 9.68961V4H10.3104L4.17543 10.1343L4.17535 10.1344C4.1196 10.1901 4.07538 10.2563 4.04521 10.3291C4.01504 10.4019 3.99951 10.48 3.99951 10.5588C3.99951 10.6376 4.01504 10.7157 4.04521 10.7885C4.07538 10.8613 4.1196 10.9275 4.17535 10.9832L4.17545 10.9833L8.99433 15.8022L9.01671 15.8245L9.01701 15.8248C9.07271 15.8806 9.13885 15.9249 9.21166 15.955C9.28446 15.9852 9.3625 16.0008 9.44132 16.0008C9.52015 16.0009 9.5982 15.9854 9.67102 15.9552C9.74379 15.9251 9.80992 15.8809 9.86563 15.8253L9.86572 15.8252L9.86577 15.8251L16 9.68961ZM11.3498 7.30012C11.3498 8.04572 11.9543 8.65016 12.6999 8.65016C13.4455 8.65016 14.0499 8.04572 14.0499 7.30012C14.0499 6.55451 13.4455 5.95007 12.6999 5.95007C11.9543 5.95007 11.3498 6.55451 11.3498 7.30012Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "d5d72ff2e19fb211b4d2af84bace99a0.svg";
export { ForwardRef as ReactComponent };